import { gql } from "@apollo/client";

export const SET_AUTHENTICATION = gql`
  mutation SetAuthentication($type: String) {
    SetAuthentication(type: $type) {
      access_token
      expires_in
    }
  }
`;
